import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { PlessSharedModule } from "../../../shared/pless-shared.module";
import { AppCommonsModule } from "../../../commons/app-commons.module";
import { WjNavModule } from "@grapecity/wijmo.angular2.nav";
import { WjInputModule } from "@grapecity/wijmo.angular2.input";
import { WjGridModule } from "@grapecity/wijmo.angular2.grid";
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter';

import { KYMW1201Component } from "./kymw1201.component";
import { GetCatalogInfo } from './api-services/get-catalog-info-service';
import { GetFeatureCodeList } from './api-services/get-feature-code-list-service';
import { GetPublishPlanGoodsCategoryListInfo } from './api-services/get-publish-plan-goods-category-list-info-service';
import { GetOrderNumQuotaList } from './api-services/get-order-num-quota-list.service';
import { RegistCycleInfo } from './api-services/regist-cycle-info-service';
import { SaveCycleInfo } from './api-services/save-cycle-info-service';
import { GetCodeListService } from 'src/app/commons/kymw02/api-services/get-code-list.service';
import { OutputPublishPlanGoodsCategoryListInfo } from "./api-services/output-publish-plan-goods-category-list-info.service";
import { FileDownloadService } from "../../../commons/kymw02/file-download-confirm/file-download.service";
import { GetFolioService } from "./api-services/get-folio-service";
import { GetBuyerCodeForAgentService } from "./api-services/get-buyer-code-for-agent.service";
import { DeleteCyclePlanGoodsCrossService } from "./api-services/delete-cycle-plan-goods-cross.service";

/**
 * 企画回別商品一覧画面 モジュール設定クラス
 *
 * @export KYMW1201Module
 * @class KYMW1201Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjNavModule,
    WjInputModule,
    WjGridModule,
    WjGridFilterModule,
  ],
  declarations: [KYMW1201Component],
  providers: [
    GetCatalogInfo,
    GetFeatureCodeList,
    GetPublishPlanGoodsCategoryListInfo,
    GetOrderNumQuotaList,
    RegistCycleInfo,
    SaveCycleInfo,
    GetCodeListService,
    OutputPublishPlanGoodsCategoryListInfo,
    FileDownloadService,
    GetFolioService,
    GetBuyerCodeForAgentService,
    DeleteCyclePlanGoodsCrossService,
  ],
})
export class KYMW1201Module {}
